<template>
    <v-card :class="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-5'">
        <LiveTradesTable></LiveTradesTable>
    </v-card>
</template>
<script>
import LiveTradesTable from "./LiveTradesTable.vue";
export default {
    components: { LiveTradesTable },
};
</script>
